class AccountDrawer extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.section = document.querySelector(`#${this.dataset.productInfo}`);
      this.querySelector('[id^="Drawer-Overlay"]').addEventListener('click', this.close.bind(this));
      this.setAccessibility();
    }
    setAccessibility() {
      const trigger = document.querySelector(`[data-drawer="${this.id}"]`);
      if (!trigger) return;
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.show(trigger);
      });
      trigger.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.show(trigger);
        }
      });
    }

    show(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      this.opening = true;
      // here the animation doesn't seem to always get triggered. A timeout seem to help
      setTimeout(() => {
        this.classList.add('animate', 'active');
      });

      this.addEventListener(
        'transitionend',
        () => {
          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
          trapFocus(this, focusElement);
          if(this.initialized) return;
          if(this.dataset.type == 'register' ) {
            fetch('/account/register?section_id=main-register-drawer').then((response) => response.text()).then((responseText) => {
              let html =  new DOMParser().parseFromString(responseText, "text/html");
              let mainRegister = html.querySelector('.main-register');
              this.setInnerHTML(this.querySelector('.drawer__contents'), mainRegister.innerHTML);
              this.querySelector('.login-link a').addEventListener('click',e =>{
                e.preventDefault()
                document.querySelector('#Login-drawer').show()
                this.close()

              })
              this.initialized  = true
            });
          }else{
            fetch('/account/login?section_id=main-login-drawer').then((response) => response.text()).then((responseText) => {
              let html =  new DOMParser().parseFromString(responseText, "text/html");
              let mainLogin = html.querySelector('.main-login');
                this.setInnerHTML(this.querySelector('.drawer__contents'), mainLogin.innerHTML);
                this.querySelector('.register-link a').addEventListener('click',e =>{
                  e.preventDefault()
                  document.querySelector('#Register-drawer').show()
                  this.close()

                })
              this.initialized  = true

              });
        }
          
        },
        { once: true }
      );
      setTimeout(()=>{
        document.body.classList.add('account-overflow-hidden');
      })
    }

    close() {
      this.classList.remove('active');
      removeTrapFocus(this.activeElement);
      document.body.classList.remove('account-overflow-hidden');
    }
    setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        // Run them in order, waiting for external <script src> tags to finish loading before
        // running the next one, so inline scripts that depend on a CDN lib (e.g. intlTelInput)
        // don't execute before that lib has loaded.
        const oldScripts = Array.from(element.querySelectorAll('script'));

        const runScript = (oldScriptTag) => new Promise((resolve) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));

          if (newScriptTag.src) {
            newScriptTag.addEventListener('load', resolve);
            newScriptTag.addEventListener('error', resolve);
          }

          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);

          if (!newScriptTag.src) resolve();
        });

        oldScripts.reduce((chain, scriptTag) => chain.then(() => runScript(scriptTag)), Promise.resolve());
      }
  }
  customElements.define('account-drawer', AccountDrawer);